import { ProductRef, ProductA2c } from '../../../models/offer';
import { safe } from '../../../../shared/utils/safe';

export function createProductCardUrl(productRef: ProductRef) {
	if (!productRef.description.configurationRef
		&& !productRef.description.productRef) {
		throw new Error(`product reference not found ${ JSON.stringify(productRef) }`);
	}
	return `/product/card/${ safe(productRef.description.productRequestId) }`;
}

export function createA2CProductCardUrl(productA2C: ProductA2c) {
	return `/product/productCard/${ safe(productA2C.inquiryNumber) }`;
}
